'use client'

import { styled, useTheme } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { RootStyles } from '@components/RootPageContainer'
import FAQ from '@components/HomeSections/faq'
import { Footer } from '@components/Footer'
import { DewiColorsDark1, DewiColorsDark9 } from '@furry/tokens'

const FooterRoot = () => {
  const theme = useTheme()

  const [win, setWin] = useState(null)

  useEffect(() => {
    setWin(window)
  }, [])

  const rootStyles = useMemo(
    () => RootStyles(theme, win?.innerWidth),
    [theme, win?.innerWidth],
  )

  const FooterRoot = styled('div', { label: 'FooterRoot' })(() => ({
    ...(rootStyles as any),
    background: DewiColorsDark9,
    position: 'relative',
  }))

  return (
    <FooterRoot>
      <FAQ />
      <Footer />
    </FooterRoot>
  )
}

export default FooterRoot
